export default __webpack_public_path__ + "static/media/leaf.24e70d2a.svg";